import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { FacilityIcon } from 'components/Accommodation/Facilities/FacilityIcon';
import { filterMessages } from 'components/Filters/filterMessages';
import { FacetType } from 'types/Search';
import { getFacetsSortedAlphabetically, MAX_MOBILE_POPULAR_FACILITIES } from 'utils/facilities';
import { isFacetSelected } from 'utils/filters';
import { Accordion } from '@daedalus/atlas/Accordion';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { FacetCard } from '../FacetCard';
import { FacetFilterProps } from '../FacetFilter';
import { FacetFilterList } from '../FacetFilterList/FacetFilterList';
const FacetCardWrapper = /*#__PURE__*/styled('div')({
  name: "FacetCardWrapper",
  class: "f1iwtnns",
  propsAsIs: false
});
interface FacetsRenderCardProps extends FacetFilterProps {
  popularFacets: FacetType[];
  validFacets: FacetType[];
}
export const FacetsRenderCard: React.FC<FacetsRenderCardProps> = ({
  popularFacets,
  validFacets,
  searchParamName,
  getLabel,
  onChange,
  columns,
  filters,
  contractedMessage
}) => {
  const {
    formatMessage
  } = useIntl();
  const [showMore, setShowMore] = React.useState(false);
  const facetsCard = popularFacets.slice(0, MAX_MOBILE_POPULAR_FACILITIES);
  return <div>
      <FacetCardWrapper>
        {facetsCard.map(facet => <FacetCard key={facet.id} icon={<FacilityIcon facility={{
        id: +facet.id,
        objectID: facet.id
      }} size="lg" />} label={getLabel(facet.id) as string} isSelected={isFacetSelected(filters, facet.id)} onSelectCard={() => onChange(searchParamName, facet.id)} />)}
      </FacetCardWrapper>

      <Accordion isBottomAligned size="sm" header={showMore ? <FormattedMessageWrapper id="showLess" defaultMessage="Show less" /> : <FormattedMessageWrapper id="showMore" defaultMessage="Show more" />} onToggle={setShowMore}>
        {showMore && <FacetFilterList title={formatMessage(filterMessages.allTypes)} facets={getFacetsSortedAlphabetically(validFacets, getLabel as (T: string) => string)} filters={filters} searchParamName={searchParamName} getLabel={getLabel} columns={columns} contractedMessage={contractedMessage} onChange={onChange} />}
      </Accordion>
    </div>;
};

require("./FacetsRenderCard.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacetsRenderCard.tsx");